export function getConsignmentUrl(
  consignmentKey: string,
  options: { queryParamsToOmit?: string[]; queryParams?: Record<string, string> } = {},
) {
  // Preserve current URL search params to maintain filters when navigating
  const currentSearchParams = new URLSearchParams(window.location.search)
  if (options.queryParamsToOmit) {
    options.queryParamsToOmit.forEach((param) => {
      currentSearchParams.delete(param)
    })
  }
  if (options.queryParams) {
    Object.entries(options.queryParams).forEach(([key, value]) => {
      currentSearchParams.set(key, value)
    })
  }
  const searchParamsString = currentSearchParams.toString()
  const queryString = searchParamsString ? `?${searchParamsString}` : ''

  return `/consignments/${consignmentKey}/clustering${queryString}`
}

export const getConsignmentsUrlWithCurrentParams = () => {
  const currentSearchParams = new URLSearchParams(window.location.search)
  return currentSearchParams.toString()
    ? `/consignments?${currentSearchParams.toString()}`
    : '/consignments'
}
